





































































import Vue from 'vue'
import IconItem from '@/components/IconItem.vue'
import store from '@/store'
import { clearAuth } from '@/helpers'

export default Vue.extend({
	components: {
		IconItem
	},

	data() { return {

		}
	},

	methods: {
		goHome() {
			//this.$emit("minimize");
			if (store.state.isMobile) {
				this.$emit("toggleMobileMenu")
			}
			
			this.$router.push({name: 'Itsepalvelu', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		logout() {
			let org = this.$store.state.org;
			this.$router.push({ name: 'Home', params: { org: org } });
			clearAuth(this.$store);
			alert('Signed out');
		},
		enterAbilitatorPage() {
			//this.$emit("minimize");
			if (store.state.isMobile) {
				this.$emit("toggleMobileMenu")
			}
			this.$router.push({name: 'Kykyviisari', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		enterSkillboard() {
			//this.$emit("minimize");
			if (store.state.isMobile) {
				this.$emit("toggleMobileMenu")
			}
			
			this.$router.push({name: 'Skillboard', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		enterKeywordsAndJobsPage() {
			//this.$emit("minimize");
			if (store.state.isMobile) {
				this.$emit("toggleMobileMenu")
			}
			this.$router.push({name: 'KeywordsAndJobs', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		enterServiceRequirementPage() {
			//this.$emit("minimize");
			if (store.state.isMobile) {
				this.$emit("toggleMobileMenu")
			}
			this.$router.push({name: 'ServiceRequirement', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		}
	},

	computed: {
		isMobile() {
			return store.state.isMobile
		},
		skillBoardEnabled() {
			return this.$store.state.orgServices?.includes('taitotaulu')
		},
		abilitatorEnabled() {
			return this.$store.state.orgServices?.includes('kykyviisari')
		},
		headaiEnabled() {
			return this.$store.state.orgServices.includes("headai");
		},
		serviceRequirementEnabled(){
			return this.$store.state.orgServices.includes("palvelutarpeenarviointi");
		},
		headaiJobsEnabled() {
			return this.$store.state.orgServices.includes("työpaikkasuositukset");
		}
	}
})
